import {BudgetThresholdBanner} from '@github-ui/in-product-targeting'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import {codeViewLayoutRoute} from '../routes/code-view-layout-route'

/**
 * Renders the actor-scoped billing budget-threshold banner on the UI service
 * code-view route. Data is supplied by the `budgetThresholdBanner` streaming
 * query registered on `codeViewLayoutRoute`. Renders nothing until/unless the
 * monolith returns an eligible banner payload.
 *
 * Mounted only in the UI service build (see {@link CodeViewLayout}); on dotcom
 * the Rails `_default_container` IncludeFragment renders this banner instead.
 */
export function BudgetThresholdBannerSlot() {
  const {data} = useRouteQuery(codeViewLayoutRoute, 'budgetThresholdBanner')

  if (!data?.banner || !data.ctaHref || !data.analytics) {
    return null
  }

  return <BudgetThresholdBanner banner={data.banner} ctaHref={data.ctaHref} analytics={data.analytics} />
}
